export type ServiceCategory = "Masaj" | "Spa" | "Kese Köpük" | "Sauna" | "Buhar" | "Tuz Odası" | "Paket Hizmet";

export interface Service {
  id: string;
  name: string;
  category: ServiceCategory;
  duration: number;
  price: number;
  commission: number;
  active: boolean;
  description: string;
}

export const serviceCategories: ServiceCategory[] = [
  "Masaj", "Spa", "Kese Köpük", "Sauna", "Buhar", "Tuz Odası", "Paket Hizmet",
];

export const services: Service[] = [
  {
    id: "srv-001",
    name: "Klasik Masaj (60 dk)",
    category: "Masaj",
    duration: 60,
    price: 750,
    commission: 120,
    active: true,
    description: "Tüm vücut gevşetici masaj, ılık yağlarla uygulanır.",
  },
  {
    id: "srv-002",
    name: "Sıcak Taş Masajı (90 dk)",
    category: "Masaj",
    duration: 90,
    price: 1200,
    commission: 200,
    active: true,
    description: "Sıcak bazalt taşları ile derin gevşeme terapisi.",
  },
  {
    id: "srv-003",
    name: "Aromaterapi Masajı",
    category: "Masaj",
    duration: 75,
    price: 950,
    commission: 150,
    active: true,
    description: "Özel uçucu yağ karışımlarıyla stres atma masajı.",
  },
  {
    id: "srv-004",
    name: "Sporcu Masajı",
    category: "Masaj",
    duration: 60,
    price: 850,
    commission: 140,
    active: true,
    description: "Kas ağrıları ve sertlik için yoğun masaj teknikleri.",
  },
  {
    id: "srv-005",
    name: "Medikal Masaj",
    category: "Masaj",
    duration: 45,
    price: 900,
    commission: 150,
    active: true,
    description: "Doktor önerisiyle uygulanan tedavi odaklı masaj.",
  },
  {
    id: "srv-006",
    name: "SPA Günü Paketi",
    category: "Spa",
    duration: 180,
    price: 2500,
    commission: 350,
    active: true,
    description: "Masaj, cilt bakımı, sauna ve spa havuzu içeren tam gün paket.",
  },
  {
    id: "srv-007",
    name: "Detoks SPA Paketi",
    category: "Spa",
    duration: 150,
    price: 2200,
    commission: 300,
    active: true,
    description: "Vücut detoksu odaklı peeling, masaj ve buhar odası.",
  },
  {
    id: "srv-008",
    name: "Anti-Aging Cilt Bakımı",
    category: "Spa",
    duration: 90,
    price: 1300,
    commission: 200,
    active: true,
    description: "Yaşlanma karşıtı serumlar ve özel masaj teknikleri.",
  },
  {
    id: "srv-009",
    name: "Tüm Vücut Peeling",
    category: "Spa",
    duration: 60,
    price: 850,
    commission: 130,
    active: true,
    description: "Doğal mineralli peeling ile cilt yenileme.",
  },
  {
    id: "srv-010",
    name: "Kese Köpük",
    category: "Kese Köpük",
    duration: 45,
    price: 450,
    commission: 70,
    active: true,
    description: "Geleneksel Türk hamamı kese köpük ritüeli.",
  },
  {
    id: "srv-011",
    name: "Kese Köpük + Masaj",
    category: "Paket Hizmet",
    duration: 90,
    price: 1100,
    commission: 170,
    active: true,
    description: "Kese köpük ardından gevşetici masaj paketi.",
  },
  {
    id: "srv-012",
    name: "Finnish Sauna",
    category: "Sauna",
    duration: 60,
    price: 400,
    commission: 50,
    active: true,
    description: "Kuru ısı ile detoks ve gevşeme.",
  },
  {
    id: "srv-013",
    name: "Buhar Odası",
    category: "Buhar",
    duration: 30,
    price: 350,
    commission: 40,
    active: true,
    description: "Nemli ısı ile cilt temizliği ve solunum rahatlatma.",
  },
  {
    id: "srv-014",
    name: "Tuz Odası (Haloterapi)",
    category: "Tuz Odası",
    duration: 45,
    price: 500,
    commission: 60,
    active: true,
    description: "Tuz mikropartikülleriyle solunum terapisi.",
  },
  {
    id: "srv-015",
    name: "Cilt Bakımı + Masaj Paketi",
    category: "Paket Hizmet",
    duration: 120,
    price: 1800,
    commission: 250,
    active: true,
    description: "Anti-aging cilt bakımı ardından gevşetici masaj.",
  },
  {
    id: "srv-016",
    name: "Profesyonel Manikür",
    category: "Spa",
    duration: 60,
    price: 500,
    commission: 80,
    active: true,
    description: "Kesme, şekillendirme, oje ve el bakımı.",
  },
  {
    id: "srv-017",
    name: "Profesyonel Pedikür",
    category: "Spa",
    duration: 60,
    price: 600,
    commission: 90,
    active: true,
    description: "Ayak bakımı, törpü, oje ve masaj.",
  },
  {
    id: "srv-018",
    name: "Profesyonel Pedikür + Manikür",
    category: "Paket Hizmet",
    duration: 90,
    price: 1050,
    commission: 160,
    active: true,
    description: "Manikür ve pedikür birleşik bakım paketi.",
  },
];